var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-2 ml-2 mr-2",attrs:{"elevation":"0"}},[_c('AdminInsentif')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }